import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';
import { GET_APPLICATIONS_SETTING_BY_ID } from './get-applications-setting-by-id.hook';
import { GET_APPLICATIONS_SETTING } from './get-applications-setting.hook';
import { GET_APPLICATIONS_EUA_SETTING } from './get-application-company-setting.hook';

export const CREATE_APPLICATIONS_SETTINGS = gql`
  mutation createApplicationsSetting($payload: CreateApplicationsSettingInput!) {
    createApplicationsSetting(payload: $payload) {
      _id
      companyId
    }
  }
`;

export const useCreateApplicationsSetting = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('settings');
  const [createApplicationsSetting, { loading }] = useMutation(CREATE_APPLICATIONS_SETTINGS, {
    onCompleted: data => {
      if (data?.createApplicationsSetting?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('applications.notifications.updated'),
        });
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    refetchQueries: [
      GET_APPLICATIONS_SETTING_BY_ID,
      GET_APPLICATIONS_SETTING,
      GET_APPLICATIONS_EUA_SETTING,
    ],
  });
  return { createApplicationsSetting, loading };
};
